const defaultState = {
  requesting: false,
  error: false,
  result: null
};

export default function counter(state = defaultState, action) {
  switch (action.type) {
    case 'TOKEN_VALIDATION_RESET':
      return defaultState
    case 'TOKEN_VALIDATION_REQUESTED':
      return {
        requesting: true,
        error: false,
        result: null
      }
    case 'TOKEN_VALIDATION_SUCCEEDED':
      return {
        requesting: false,
        error: false,
        result: action.payload
      }
    case 'TOKEN_VALIDATION_FAILED':
      return {
        requesting: false,
        error: true,
        result: action.payload
      }
    default:
      return state
  }
}
